var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelgramIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10152_4537)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H12C5.37258 0 0 5.37258 0 12V28C0 34.6274 5.37258 40 12 40H28C34.6274 40 40 34.6274 40 28V12C40 5.37258 34.6274 0 28 0Z",
    fill: "#FCFCFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10152_4537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8H8V32H32V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10152_4537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3797 10.5516L9.12064 18.1049C7.66979 18.6419 7.67818 19.3876 8.85445 19.7201L14.3125 21.2889L26.9409 13.9477C27.538 13.6129 28.0836 13.793 27.6351 14.1598L17.4037 22.6677H17.4013L17.4037 22.6688L17.0272 27.8524C17.5787 27.8524 17.8221 27.6193 18.1315 27.3442L20.7826 24.9689L26.297 28.7218C27.3138 29.2378 28.044 28.9726 28.297 27.8546L31.9169 12.1359C32.2874 10.767 31.3498 10.1473 30.3797 10.5516Z",
    fill: "#18191D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10152_4537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelgramIconWhite);
export default __webpack_public_path__ + "static/media/telgramIconWhite.e2cd68ddcda9c49be6006a15bb3972ea.svg";
export { ForwardRef as ReactComponent };